import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'

export function FixedCreateAccountButton() {
  const intl = useIntl()

  return (
    <div className='fixed-bottom d-flex justify-content-center transition-linear mobile-only mb-7'>
      <Link
        to='/auth/registration'
        className='fixed-account-create-btn btn btn-outline btn-primary-deep btn-darker hover-orange fw-bold text-capitalize rounded-pill py-6'
      >
        {intl.formatMessage({id: 'TRY_IT_FREE'})}
      </Link>
    </div>
  )
}
